import { kebabCase } from 'lodash';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useHistory } from 'react-router-dom';

import { Container, Jumbo, tokens } from '@treams/treams-ui';

import SettingsEdit from './SettingsEdit';
import SettingsList from './SettingsList';
import { FormData } from './types';

type Props = {
	formData: FormData;
};

const SettingsEntity: FC<Props> = ({ formData }) => {
	const history = useHistory();
	const { t } = useTranslation();

	const libraryPath = useMemo(() => {
		const subjectPathComponent = kebabCase(formData.subject.plural);
		return `/settings/${subjectPathComponent}`;
	}, [formData.subject.plural]);

	const backButtonLink = history.location.pathname !== libraryPath ? libraryPath : undefined;

	return (
		<>
			<Jumbo
				backButtonLink={backButtonLink}
				title={t(`settings.${formData.subject.plural}.title`)}
				description={t(`settings.${formData.subject.plural}.description`)}
			/>

			<Container pt={`${tokens.gap.page}px`} pb={4}>
				<Switch>
					<Route path={`${libraryPath}/new`}>
						<SettingsEdit formData={formData} libraryPath={libraryPath} />
					</Route>
					<Route path={`${libraryPath}/:id`}>
						{({ match }) => (
							<SettingsEdit id={match!.params.id!} formData={formData} libraryPath={libraryPath} />
						)}
					</Route>
					<Route path={libraryPath}>
						<SettingsList formData={formData} libraryPath={libraryPath} />
					</Route>
				</Switch>
			</Container>
		</>
	);
};
export default SettingsEntity;
